import React from 'react'

const StreamElement = ({stream}) => {
  return (
    <>
    {stream?.Stream ? (
      <audio
      className="d-none"
      ref={(audioElement) => {
        if (audioElement) {
          // Set the stream as the source for the audio element
          audioElement.srcObject = stream?.Stream;
              
              
              // if (audioElement.currentTime === 0 && count < 3) {
              //   setTimeout(() => {
              //     if (audioElement.currentTime === 0) { // Check again after 2 sec
              //       // handleRetryConsume(obj?.producerId);
              //       setCount((prevCount) => prevCount + 1);
              //     }
              //   }, 2000);
              // }else{
              //   setCount(0)
              // }

              // Check if audio is playing
              audioElement.onplay = () => {
                // console.log('Audio is now playing', stream?.UserID);
              };

              audioElement.onerror = (error) => {
                console.error('Audio error:', error);
              };
        
              // Check if the audio is paused
              audioElement.onpause = () => {
                console.log('Audio is paused', stream?.UserID);
              };
        
              // Check if the audio is playing after 1 second
              // setInterval(() => {
              //   if (audioElement.paused) {
              //     console.log('Audio is not playing');
              //   } else {
              //     console.log('Audio is playing');
              //   }
              // }, 1000);
            
              

        }
      }}
      controls
      autoPlay
    />  
  ):('')}
  </>
  )
}

export default StreamElement